import { setVisibleMenus } from './actions';

export function init(dispatch, state, query) {

  const visibleMenus = ['simple', 'import'];

  if(state.ui.interfaceMode === 'rootsgifts') {
    if(query.showDecal) {
      visibleMenus.push('decal');
    }
  } else {
    visibleMenus.push('decal', 'advanced', 'template', 'palette', 'chart', 'generation', 'individual', 'color');
  }

  dispatch(setVisibleMenus(visibleMenus));
}


// WEBPACK FOOTER //
// ./src/core/ui/init.js